import { createReducer } from 'immutable-reducers';
import { fromJS, Map } from 'immutable';
import _ from 'lodash';

import { serverDocToClientMap } from 'app/businessRules';
import * as status from 'modules/app/constants/crudStatus';
import { VISIT_AND_UNITS, GET_DOCS, STORE_DOC, DELETE_DOC, DOCS_AND_GOODS } from '../constants/actionTypes';

const INITIAL_STATE = {
    status: status.INITIAL,
    docs: []
};

const findIndex = (state, id) => (
    _.findIndex(state.get('docs').toJS(), {id})
);

export default createReducer(['docs'], (state = fromJS(INITIAL_STATE), action) => {

    switch (action.type) {

        case GET_DOCS.REQUEST:
            return state.set('status', status.LOADING).set('docs', fromJS(INITIAL_STATE.docs));

        case GET_DOCS.ERROR:
            return state.set('status', status.ERROR).set('docs', fromJS(INITIAL_STATE.docs));

        case GET_DOCS.SUCCESS:
            return state.set('status', status.SUCCESS).set('docs', fromJS(serverDocToClientMap(action.docs)));

        case STORE_DOC.SUCCESS:
            const docIndex = findIndex(state,action.doc.id);
            if (docIndex > -1) {
                return state.set('docs', state.get('docs').set(docIndex, fromJS(serverDocToClientMap(action.doc))));
            } else {
                return state.set('docs', state.get('docs').push(fromJS(serverDocToClientMap(action.doc))));
            }

        case DELETE_DOC.SUCCESS:
            const index = findIndex(state, action.id);
            return state.set('docs', state.get('docs').delete(index));

        case DOCS_AND_GOODS.CLEAR:
        case VISIT_AND_UNITS.CLEAR:
            return fromJS(INITIAL_STATE);
        
        default:
            break;
    }

    return state;
});